module.exports = __webpack_public_path__ + "img/features-bg_2.d85a6517.png";